// Assets/product-variant-picker.js
(() => {
  // Extremely light, non-breaking shim that just re-triggers change on option inputs
  class VariantPickerShim extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', () => {
        const form = this.closest('form');
        if (!form) return;
        // Let the theme's JS handle the actual variant resolution.
        // We simply ensure change bubbles once.
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          const evt = new Event('change', { bubbles: true });
          idInput.dispatchEvent(evt);
        }
      });
    }
  }
  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPickerShim);
  }
})();